export const defaultSorted = [{ dataField: "value", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  searchFilter: "",
  typeId: 0,
  sortOrder: "desc", // asc||desc
  sortField: "value",
  pageNumber: 1,
  pageSize: 10
};
// Delete case
export const setNewQueryParams = (queryParams, totalCount, entities) => {
  const pageSize = queryParams.pageSize;
  const lastPageValue = (totalCount + pageSize - 1) / pageSize;
  const pageNumber = queryParams.pageNumber;
  const res = { isRequieredSetQueryParams: lastPageValue === pageNumber && entities.length - 1 === 0 };
  if (res.isRequieredSetQueryParams) {
    const typeId = queryParams.typeId;
    const newQueryParamsFilter = { ...initialFilter, searchFilter: "",typeId : typeId}
      res.queryParams = totalCount === 1 ? newQueryParamsFilter : { ...queryParams, pageNumber: lastPageValue - 1 };
  }
  return res;
};